import React from 'react';

const Cookie = () => {
  return (
    <div className="container">
      <div className="cookie">
        <h2 className="cookie__title">
          Политика конфиденциальности и обработки персональных данных интернет магазина
        </h2>
        <div className="cookie__terms">
          <h3 className="cookie__terms-title">Термины и определения:</h3>
          <p>
            <span className="yep">Оператор</span> — индивидуальный предприниматель Ламанова Юлия
            Викторовна (ИНН 420543086580, ОГРНИП 322420500020732)
          </p>
          <p>
            <span className="yep">Сайт</span> — совокупность программных средств, контента, баз
            данных, объединенную единым дизайном и названием «Jiva» и обеспечивающую возможность
            покупки товаров.
          </p>
          <p>
            <span className="yep">Субъект персональных данных (Заказчик)</span> — физическое лицо,
            заполнившее форму-заказа товара и совершившее акцепт настоящей Политики.
          </p>
          <p>
            <span className="yep">Прочие термины и определения</span> в Политике используются в
            соответствии с их значениями, как они определены в ФЗ-152 «О персональных данных».
          </p>
        </div>
        <div className="cookie__text">
          <h3 className="cookie__text-title">Введение:</h3>
          <p>
            Настоящая Политика конфиденциальности и обработки персональных данных (далее — Политика)
            действует в отношении всей информации, которую Оператор может получить о Заказчике во
            время использования им услуг Оператора, а также при коммуникации с Оператором в любой
            форме, в соответствии с данной Политикой.
          </p>
          <p className="strong">
            Отправка формы-заказа на Сайте означает безоговорочное согласие Заказчика с настоящей
            Политикой и указанными в ней условиями обработки его персональных данных.
          </p>
          <p className="strong">
            В случае несогласия с этими условиями Заказчик должен воздержаться от пользования
            услугами Оператора.
          </p>
          <p>
            Политика действует бессрочно после утверждения и до ее замены новой версией. <br />
            Политика является общедоступным документом, декларирующим концептуальные основы
            деятельности Оператора при обработке и защите персональной информации и персональных
            данных Заказчиков Оператора.
          </p>
          <p className="yep">
            1. Персональная информация Заказчика, которую получает и обрабатывает Оператор:
          </p>
          <p>
            1.1. В рамках настоящей Политики под персональной информацией и персональными данными
            Заказчика, которые собирает Оператор понимаются:
            <br />
            1.1.1. Персональная информация, которую Заказчик предоставляет о себе самостоятельно при
            отправке формы-заказа Товара на Сайте: фамилия, имя, отчество, адрес, контактный телефон
          </p>
          <p>
            1.1.2. Данные файлов cookie, которые автоматически передаются Оператору в процессе
            использования Сайта с помощью установленного на устройстве Заказчика программного
            обеспечения.
          </p>
          <p>
            1.2. Настоящая Политика применима только к Оператору. Владелец Оператора не контролирует
            и не несет ответственность за сайты или приложения третьих лиц, на которые Заказчик
            может перейти по ссылкам, размещенным на Сайте Оператора, в том числе за обрабатываемую
            третьими лицами информацию о Пользователе.
          </p>
          <p>
            1.3. За исключением случаев идентификации Заказчиков по основаниям и в порядке,
            предусмотренным применимыми соглашениями Оператора и Заказчика, Оператор не проверяет
            достоверность персональной информации, предоставляемой Заказчиком, и не осуществляет
            контроль за их дееспособностью. Однако Оператор исходит из того, что Заказчик
            предоставляет достоверную и достаточную персональную информацию.
          </p>
          <p className="yep">2. Цели сбора и обработки персональной информации Заказчика:</p>
          <p>
            2.1. Оператор собирает и хранит только ту персональную информацию, которая необходима
            для выполнения Оператором договора с Заказчиками.
          </p>
          <p>
            2.2. Персональную информацию Заказчика Оператор может использовать в следующих целях:{' '}
            <br />
            2.2.3. Проведения статистических и иных исследований.
            <br />
            2.2.4. Публикации в социальных сетях фото- и видеоматериалов с участием Заказчика,
            сделанных Оператором или Заказчиком во время или после покупки Товара.
          </p>
          <p>
            2.2.5. Проведения маркетинговых акций для Заказчиков в целях: <br />
            -распространения предложений об участии в акциях и получения предусмотренных акцией
            призов/вознаграждений; <br />
            -распространения рекламно-информационных материалов по сетям электросвязи, в том числе
            посредством использования телефонной связи или путем прямых контактов; и иной
            информации, доводимой до сведения Заказчика;
          </p>
          <p>
            2.3.Оператор не осуществляет обработку биометрических персональных данных Заказчика
            (сведения, которые характеризуют физиологические и биологические особенности человека,
            на основании которых можно установить его личность).
          </p>
          <p>
            2.4. Оператор не выполняет обработку специальных категорий персональных данных,
            касающихся расовой, национальной принадлежности, политических взглядов, религиозных или
            философских убеждений, состояния здоровья, интимной жизни.
          </p>
          <p>
            2.5. Оператор не производит трансграничную (на территорию иностранного государства
            органу власти иностранного государства, иностранному физическому лицу или иностранному
            юридическому лицу) передачу персональных данных Заказчика.
          </p>
          <p>
            2.6. Оператором не принимаются решения, порождающие юридические последствия в отношении
            субъектов персональных данных или иным образом затрагивающие их права и законные
            интересы, на основании исключительно автоматизированной обработки их персональных
            данных.
          </p>
          <p className="yep">
            3. Условия обработки персональной информации Заказчиков и её передачи третьим лицам:
          </p>
          <p>
            3.1. Оператор хранит персональную информацию Заказчика в соответствии с настоящей
            Политикой, условиями оказания конкретных услуг и внутренними регламентами Оператора.
          </p>
          <p>
            3.2. В отношении персональной информации Заказчика обеспечивается ее конфиденциальность.
          </p>
          <p>
            3.3. Владелец Оператора вправе передать персональную информацию Пользователей третьим
            лицам в следующих случаях:
            <br />
            3.3.1. Заказчик выразил свое согласие на такие действия;
          </p>
          <p>
            3.3.2. Передача необходима для использования определенной услуги Оператора, в том числе
            для исполнения определенного распоряжения Заказчика;
          </p>
          <p>
            3.3.3. Передача предусмотренная российским или иным применимым законодательством в
            рамках установленной законодательством процедуры;
          </p>
          <p>
            3.3.4. Передача происходит в рамках продажи или иной передачи бизнеса (полностью или в
            части), при этом к приобретателю переходят все обязательства по соблюдению условий
            настоящей Политики применительно к полученной им персональной информации;
          </p>
          <p>
            3.3.5. В целях обеспечения возможности защиты прав и законных интересов Оператора или
            третьих лиц в случаях, когда у Оператора имеются достаточные основания полагать, что
            Заказчик нарушает условия применимого соглашения (договора) с Оператором и/или
            требования применимого законодательства. <br />
            3.4. При обработке персональных данных Заказчиков Оператор руководствуется Федеральным
            законом «О персональных данных».
          </p>
          <p className="yep">
            4. Изменение и удаление Заказчиком персональной информации или персональных данных:
          </p>
          <p>
            4.1. В соответствии с требованиями законодательства на Оператора может быть возложена
            обязанность осуществлять обработку / хранение полученной при пользовании услугами
            Оператора персональной информации Заказчика. Такая обработка / хранение осуществляется
            Оператором в случаях, по основаниям и в течение сроков, установленных законодательством.
          </p>
          <p>
            4.2. Оператор прекращает обработку персональной информации и персональных данных
            Пользователей: <br />
            — при наступлении условий прекращения обработки персональных данных или по истечении
            установленных сроков;
            <br />
            — по достижении целей их обработки либо в случае утраты необходимости в достижении этих
            целей;
            <br />
            — по требованию Заказчика, если обрабатываемые персональные данные являются незаконно
            полученными или не являются необходимыми для заявленной цели обработки;
            <br />
            — в случае выявления неправомерной обработки персональных данных, если обеспечить
            правомерность обработки невозможно;
            <br />
            — по истечении срока действия согласия Заказчика на обработку персональных данных или в
            случае отзыва Заказчиком такого согласия, если для обработки персональных данных не
            будет иных правовых оснований, предусмотренных законодательством Российской Федерации;
            <br />
            — в случае прекращения работы Оператора.
            <br />
            4.3. Права Заказчика как субъекта персональных данных
            <br />
            4.3.1. Заказчик имеет право на получение сведений об обработке его персональных данных
            Оператором.
          </p>
          <p>
            4.3.2. Заказчик вправе требовать от Оператора уточнения этих персональных данных, их
            блокирования или уничтожения в случае, если они являются неполными, устаревшими,
            неточными, незаконно полученными или не могут быть признаны необходимыми для заявленной
            цели обработки, а также принимать предусмотренные законом меры по защите своих прав.
          </p>
          <p>
            4.3.3. Право Заказчика на доступ к его персональным данным может быть ограничено в
            соответствии с федеральными законами, в том числе, если доступ Заказчика к его
            персональным данным нарушает права и законные интересы третьих лиц.
          </p>
          <p>
            4.3.4. Для реализации и защиты своих прав и законных интересов Заказчик имеет право
            обратиться к Оператору. Оператор рассматривает любые обращения и жалобы со стороны
            Заказчика, тщательно расследует факты нарушений и принимает все необходимые меры для их
            немедленного устранения, наказания виновных лиц и урегулирования спорных и конфликтных
            ситуаций в досудебном порядке
          </p>
          <p>
            4.3.5. Заказчик вправе обжаловать действия или бездействие Оператора путем обращения в
            уполномоченный орган по защите прав субъектов персональных данных.
          </p>
          <p>
            4.3.6. Заказчик имеет право на защиту своих прав и законных интересов, в том числе на
            возмещение убытков и/или компенсацию морального вреда в судебном порядке.
          </p>
          <p className="yep">
            5. Меры, применяемые для защиты персональной информации Пользователей:
          </p>
          <p>
            5.1. Оператор принимает необходимые и достаточные организационные и технические меры для
            защиты персональной информации Заказчика от неправомерного или случайного доступа,
            уничтожения, изменения, блокирования, копирования, распространения, а также от иных
            неправомерных действий с ней третьих лиц.
          </p>
          <p>
            5.2. Защиту и обработку персональных данных Заказчика Оператор производит в соответствии
            с требованиями Федерального закона «О персональных данных», Постановления Правительства
            РФ «Об утверждении требований к защите персональных данных при их обработке в
            информационных системах персональных данных» No 1119 от 01 ноября 2012 г., Постановления
            Правительства РФ от 15 сентября 2008 г. No687 «Об утверждении Положения об особенностях
            обработки персональных данных, осуществляемой без использования средств автоматизации».
          </p>
          <p>
            5.3. При обработке персональных данных Оператор обеспечивает их безопасность и принимает
            необходимые организационные и технические меры для защиты персональных данных от
            неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования,
            копирования, распространения персональных данных, а также от иных неправомерных
            действий, путем установления в отношении таких данных режима конфиденциальности и
            контроля за его соблюдением, а также путем внедрения дополнительных мер защиты,
            реализующих требования законодательства Российской Федерации, стандартов и внутренних
            организационно-распорядительных документов Оператора.Реализуются следующие требования к
            защите персональных данных: <br />
            — определение угроз безопасности персональных данных при их обработке в информационных
            системах Оператора;
            <br />
            — обнаружение фактов несанкционированного доступа к персональным данным и принятие мер;
            <br />
            — восстановление персональных данных, модифицированных или уничтоженных вследствие
            несанкционированного доступа к ним;
            <br />
            — установление правил доступа к персональным данным, обрабатываемым в информационной
            системе;
            <br />
          </p>
          <p className="yep">6. Изменение настоящей Политики. Применимое законодательство</p>
          <p>
            6.1. Оператор вправе изменить и/или дополнить настоящую Политику путем опубликования
            Политики в новой редакции на Сайте Оператора по адресу
            <span className="yep">
              <a href="https://jivalab.ru/" rel="noreferrer">
                https://jivalab.ru/
              </a>
            </span>
            . Принятием Заказчиком такого предложения являются конклюдентные действия по пользованию
            услугами Оператора на новых условиях.
          </p>
          <p>
            6.2. К настоящей Политике и отношениям между Заказчиком и Оператором, возникающим в
            связи с применением Политики, подлежит применению законодательство Российской Федерации.
          </p>
        </div>
        <div className="cookie__text">
          <h3 className="cookie__text-title">Политика использования файлов «cookie»</h3>
          <p>
            <span className="strong">Посещая настоящий сайт jivalab.ru </span>(ИП Ламанова Юлия
            Викторовна, ИНН 420543086580, ОГРНИП 322420500020732 (далее – «Jiva») в
            информационно-телекоммуникационной сети «Интернет» (далее — сеть «Интернет»), действуя
            свободно, в своем интересе и, выражая свою волю,{' '}
            <span className="strong">
              {' '}
              вы соглашаетесь с настоящей Политикой в отношении использования файлов «cookie»{' '}
            </span>{' '}
            Jiva, в том числе с тем, что Jiva может обрабатывать файлы «cookie» самостоятельно или с
            привлечением Сервиса Яндекс.Метрика, в целях указанных ниже.
          </p>
          <p>
            <span className="strong">Под обработкой понимаются</span> любые действия с
            использованием средств автоматизации, предусмотренные Федеральным законом от 27.07.2006
            г. № 152-ФЗ «О персональных данных», включая сбор, запись, систематизацию, накопление,
            хранение, уточнение (обновление, изменение), извлечение, использование, передачу
            (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение
            обрабатываемых данных.
          </p>
          <p>
            <span className="strong">Под файлами «cookie» понимаются</span> данные о пользователях
            сайта Jiva, доступные и собираемые Jiva самостоятельно или с привлечением Сервиса
            Яндекс.Метрика, а именно: адрес пользователя или адрес устройства пользователя и его
            технические характеристики, посредством которого пользователь зашел на сайт Jiva,
            используемая операционная система на устройстве пользователя, версия операционной
            системы, а также сведения о пользователе, включающие IP-адрес, поисковые запросы
            пользователя, информация об используемом браузере и языке, даты и времени доступа к
            сайту, интернет-адреса веб-страниц, посещаемых пользователем, тематику информации,
            размещенной на посещаемых пользователем интернет — ресурсах Jiva, идентификатор
            устройства, географическое положение, количество просмотренных страниц, длительность
            пребывания на сайте Jiva, запросы, которые пользователь использовал при переходе на
            сайт, страницы, с которых были совершены переходы, сведения о мобильном устройстве, в
            т.ч. идентификатор устройства, сведения о местоположении, данные о настройках системы,
            User-Agent пользователя, источник рекламного трафика, идентификатор сессии,
            идентификаторы систем, посещаемых пользователем, дата/время использования сервиса и
            любая информация, не позволяющая однозначно идентифицировать пользователя или конкретное
            физическое лицо, для предоставления пользователю рекламной информации и аналитическая
            пользовательская информация.Выбор состава файлов «cookie» для обработки зависит от
            используемого браузера и устройства.
          </p>
          <p>
            <span className="strong">Файлы «cookie» Jiva могут использоваться для:</span> <br />
            — усовершенствования существующих и разработки новых продуктов и (или) услуг Jiva;
            <br />
            — ведения статистики о пользователях
            <br />— обеспечения функционирования и улучшения качества сайта и продуктов Jiva;
          </p>
          <p>
            Файлами «cookie» вы можете управлять самостоятельно. Используемый Вами браузер и (или)
            устройство может позволять блокировать, удалять или иным образом ограничивать
            использование файлов «cookie». Чтобы узнать, как управлять файлами «cookie» с помощью
            используемых браузера или устройства, воспользуйтесь инструкцией, предоставляемой
            разработчиком браузера или производителем устройства, которые вы используете.
          </p>
          <p>
            Обрабатываемые файлы «cookie» уничтожаются, либо обезличиваются по достижении указанных
            выше целей обработки или в случае утраты необходимости в достижении этих целей.
          </p>
        </div>
        <div className="cookie__text">
          <h3 className="cookie__text-title">Договор-оферта интернет-магазина «Jiva»</h3>
          <p>
            ИП Ламанова Ю.В, в лице интернет-магазина «Jiva» https://jivalab.ru (далее Продавец),
            публикует настоящий договор, являющийся публичным договором-офертой в адрес как
            физических, так и юридических лиц (далее Покупатель) о нижеследующем:
          </p>
          <p className="yep">1. Предмет договора-оферты.</p>
          <p>
            1.1. Продавец обязуется передать в собственность Покупателю, а Покупатель обязуется
            оплатить и принять заказанные в интернет-магазине «Jiva» https://jivalab.ru  Товары
            (далее Товар).
          </p>

          <p className="yep">2. Момент заключения договора.</p>
          <p>
            2.1. Текст данного Договора является публичной офертой (в соответствии со статьей 435 и
            частью 2 статьи 437 Гражданского кодекса РФ).
            <br />
            2.2. Факт оформления заказа Товара у Продавца как самостоятельно, так и через оператора,
            является безоговорочным принятием данного Договора, и Покупатель рассматривается как
            лицо, вступившее с ИП Ламанова Ю.В в договорные отношения.
            <br />
            2.3. Оформление Заказа Товара и расчет осуществляется путем заказа Покупателем в
            интернет-магазине «Jiva»{' '}
            <span className="yep">
              <a href="https://jivalab.ru/" rel="noreferrer">
                https://jivalab.ru/
              </a>
            </span>
          </p>

          <p className="yep">3. Цена Товара. </p>
          <p>
            3.1. Цены в интернет-магазине указаны в валюте страны покупателя за единицу Товара.
            <br />
            3.2. Способы доставки Товара указаны в интернет-магазине на странице оформления заказа
            <br />
            3.3. Общая сумма Заказа указывается в разделе «корзина» в строке «заказать». 
          </p>

          <p className="yep">4. Оплата Товара.</p>
          <p>
            4.1. При безналичной форме оплаты обязанность Покупателя по уплате цены Товара считается
            исполненной с момента списания денежных средств в размере 100% (ста процентов)
            предоплаты с расчетного счета Покупателя в банке, кредитной организации, оказывающей в
            соответствии с действующим законодательством Российской Федерации платежные услуги
            населению, в том числе с использованием электронных денежных средств.
            <br />
            4.2. При безналичной форме оплаты просрочка уплаты Покупателем цены Товара на срок свыше
            7 (семи) дней является существенным нарушением настоящего договора. В этом случае
            Продавец вправе в одностороннем порядке отказаться от исполнения настоящего договора,
            уведомив об этом Покупателя.
            <br />
            4.3. Товары поставляются Покупателю по ценам, наименованию, в количестве,
            соответствующем счету, оплаченному Покупателем.
          </p>

          <p className="yep">5. Доставка Товара.</p>
          <p>
            5.1. Доставка Товара Покупателю осуществляется по адресу и в сроки, согласованные с
            Покупателем и менеджером Продавца при оформлении Заказа, либо Покупатель самостоятельно
            забирает Товар со склада Продавца по адресу: Кемеровский район, деревня Сухово, улица
            Ботаническая, дом 42. <br />
            5.2. Точная стоимость доставки Товара определяется менеджером Продавца при оформлении
            доставки заказа и не может быть изменена после согласования Покупателем. <br /> 5.3.
            Неявка Покупателя или не совершение иных необходимых действий для принятия Товара могут
            рассматриваться Продавцом в качестве отказа Покупателя от исполнения Договора. 
          </p>

          <p className="yep">6. Гарантии на Товар.</p>
          <p>
            6.1. На всю продукцию, продающуюся в Интернет-магазине «Jiva»
            <span className="yep">
              <a href="https://jivalab.ru/" rel="noreferrer">
                https://jivalab.ru/
              </a>
            </span>
            , имеются все необходимые сертификаты качества и санитарно-гигиенические заключения.
            <br /> 6.2. Срок годности Товара устанавливает производитель, он указан на каждой
            упаковке Товара.
          </p>
          <p className="yep">7. Права и обязанности сторон.</p>
          <p>
            7.1. Продавец обязуется: <br />
            7.1.1. До заключения договора предоставить Покупателю информацию об основных
            потребительских свойствах Товара, об адресе (месте нахождения) Продавца, о месте
            изготовления Товара, о полном фирменном наименовании (наименовании) Продавца, о цене и
            об условиях приобретения Товара, о его доставке, сроке годности, о порядке оплаты
            Товара, а также о сроке, в течение которого действует предложение о заключении Договора.
            <br /> 7.1.2. Не разглашать любую частную информацию Покупателя и не предоставлять
            доступ к этой информации третьим лицам, за исключением случаев, предусмотренных
            Российским законодательством.
            <br />
            7.1.3. Предоставить Покупателю возможность получения бесплатных телефонных консультаций
            по телефону, указанному на сайте магазина «Jiva»{' '}
            <span className="yep">
              <a href="https://jivalab.ru/" rel="noreferrer">
                https://jivalab.ru/
              </a>
            </span>{' '}
            <br />
            7.1.4. Продавец оставляет за собой право изменять настоящий Договор в одностороннем
            порядке до момента его заключения. <br /> 7.1.5. Предоставить Потребителю в момент
            доставки Товара информацию о Товаре, предусмотренную статьей 10 Федерального закона «О
            защите прав потребителей», а также предусмотренную пунктом 9 настоящего Договора
            информацию о порядке и сроках возврата Товара. <br />
            7.2. Покупатель обязуется: <br />
            7.2.1. До момента заключения Договора ознакомиться с содержанием договора-оферты,
            условиями оплаты и доставки на сайте магазина «Jiva»
            <span className="yep">
              <a href="https://jivalab.ru/" rel="noreferrer">
                https://jivalab.ru/
              </a>
            </span>
            <br />
            7.2.2. Предоставлять достоверную информацию о себе (ФИО, контактный телефон, адрес) для
            доставки Товара. <br />
            7.2.3. Принять и оплатить Товар в указанные в настоящем Договоре сроки.
          </p>
          <p className="yep">8. Ответственность сторон и разрешение споров. </p>
          <p>
            8.1. Стороны несут ответственность за неисполнение или ненадлежащее исполнение
            настоящего Договора в порядке, предусмотренном настоящим Договором и действующим
            законодательством РФ.
            <br />
            8.2. Продавец не несет ответственности за доставку Заказа, если Покупателем указан
            неправильный адрес доставки.
            <br />
            8.3. Продавец не несет ответственности, если ожидания Покупателя о потребительских
            свойствах Товара оказались не оправданы.
            <br />
            8.4. Продавец не несет ответственности за частичное или полное неисполнение обязательств
            по доставке Товара, если они являются следствием форс-мажорных обстоятельств.
            <br />
            8.5. Покупатель, оформляя Заказ, несет ответственность за достоверность предоставляемой
            информации о себе, а также подтверждает, что с условиями настоящего Договора ознакомлен
            и согласен.
            <br />
            8.6. Все споры и разногласия, возникающие при исполнении Сторонами обязательств по
            настоящему Договору, решаются путем переговоров. В случае невозможности их устранения,
            Стороны имеют право обратиться за судебной защитой своих интересов.
          </p>
          <p className="yep">9. Возврат и обмен Товара.</p>
          <p>
            9.1. Требование Покупателя об обмене либо о возврате Товара подлежит удовлетворению,
            если Товар не был в употреблении, сохранены его потребительские свойства, сохранена и не
            нарушена упаковка, сохранены документы, подтверждающие факт покупки этого Товара в
            интернет-магазине «Jiva»
            <span className="yep">
              <a href="https://jivalab.ru/" rel="noreferrer">
                https://jivalab.ru/
              </a>
            </span>
            <br />
            9.2. Срок такого требования составляет 7 (семь) дней с момента передачи Товара
            Покупателю, либо в любое время до передачи Товара Покупателю. <br />
            9.3. Покупатель компенсирует Продавцу необходимые транспортные расходы, понесенные в
            связи с организацией обмена или возврата Товара.
          </p>
          <p className="yep">10. Форс-мажорные обстоятельства. </p>
          <p>
            10.1. Стороны освобождаются от ответственности за неисполнение или ненадлежащее
            исполнение обязательств по Договору на время действия непреодолимой силы. Под
            непреодолимой силой понимаются чрезвычайные и непреодолимые при данных условиях
            обстоятельства, препятствующие исполнению своих обязательств Сторонами по настоящему
            Договору. К ним относятся стихийные явления (землетрясения, наводнения и т. п.),
            обстоятельства общественной жизни (военные действия, чрезвычайные положения, крупнейшие
            забастовки, эпидемии и т. п.), запретительные меры государственных органов (запрещение
            перевозок, валютные ограничения, международные санкции запрета на торговлю и т. п.). В
            течение этого времени Стороны не имеют взаимных претензий, и каждая из Сторон принимает
            на себя свой риск последствия форс-мажорных обстоятельств. 
          </p>
          <p className="yep">11. Срок действия договора. </p>
          <p>
            11.1. Настоящий Договор вступает в силу с момента обращения к ИП Ламанова Ю.В. и
            оформления Заказа, и заканчивается при полном исполнении обязательств Сторонами. 
          </p>
          <p className="yep">12. Персональные данные. </p>
          <p>
            12.1. Продавец собирает и обрабатывает персональные данные Покупателей (а именно:
            фамилия, имя, отчество Покупателя; адрес; контактный телефон)
            <br /> в целях:
            <br />
            - выполнения условий настоящего договора;
            <br /> - указанных в политике конфиденциальности и обработки персональных данных,
            размещенной на сайте «Jiva»{' '}
            <span className="yep">
              <a href="https://jivalab.ru/" rel="noreferrer">
                https://jivalab.ru/
              </a>
            </span>{' '}
            <br />
            12.2. Осуществляя Заказ Товара в интернет-магазине «Jiva»{' '}
            <span className="yep">
              <a href="https://jivalab.ru/" rel="noreferrer">
                https://jivalab.ru/
              </a>
            </span>
            , Покупатель дает согласие на сбор и обработку персональных данных о себе в целях
            указанных в пункте 12.1 настоящего Договора.
            <br /> 12.3. При сборе и обработке персональных данных Покупателей, Продавец не
            преследует иных целей, кроме установленных в п.12.1 настоящего Договора. <br />
            12.4. Доступ к персональным данным Покупателей имеют только лица, имеющие
            непосредственное отношение к исполнению Заказов.
          </p>
          <p className="yep">13. Реквизиты интернет магазина.</p>
          <p>
            Индивидуальный предприниматель Ламанова Юлия Викторовна <br />
            Адрес юридический: 650036 Кемеровская область-Кузбасс, город Кемерово, ул. Гагарина д.
            122 кв. 35 <br />
            Адрес производства: 650517 Кемеровская область-Кузбасс, Кемеровский р-н, д. Сухово, ул.
            Ботаническая д. 42 <br />
            Телефон:{' '}
            <a href="tel:+79235003569" rel="noreferrer">
              +79235003569
            </a>{' '}
            <br />
            E-mail:
            <a href="mailto: mail@jivalab.ru" rel="noreferrer">
              mail@jivalab.ru
            </a>{' '}
            <br />
            ИНН: 420543086580 <br />
            ОГРНИП: 322420500020732 <br />
            ОКПО: 0112453279 <br />
            Номер счета: 40817810000079658170 <br />
            Банк-получатель: АО "ТБанк" <br />
            Корреспондентский счет: 30101810145250000974 <br />
            БИК: 044525974
          </p>
        </div>
      </div>
    </div>
  );
};

export default Cookie;
